import { useMemo } from 'react'

import { get } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import actionPickupPoint from '~/modules/master/redux/actions/pickup-point'

const usePickupPoint = () => {
  const data = useSelector((state) => get(state, 'master.pickupPoint'))

  const dispatch = useDispatch()
  const actions = useMemo(
    () => bindActionCreators(actionPickupPoint, dispatch),
    [dispatch],
  )
  return {
    actions,
    data,
  }
}

export default usePickupPoint
